import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ReusableModal from "../../Components/Modal";
import Call from "../../Components/Call";
import '../../Styles/style.css';

const SessionDetails = () => {
  const [sessionList, setSessionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: "",
  });
  const [sessionType, setSessionType] = useState("Completed");
  const [sessionCount, setSessionCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [singleSession, setSingleSession] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [sessionStats, setSessionStats] = useState({
    totalSessions: 0,
    sessionsHandled: 0,
    cancelledSessions: 0,
    rescheduledSessions: 0,
    noShowSessions: 0
  });

  useEffect(() => {
    fetchUserSessionList(pageData.currentPage, entries, sessionType);
    fetchSessionStats();
  }, [pageData.currentPage, entries, sessionType]);

  useEffect(() => {
    if (dateFilter.startDate !== "" && dateFilter.endDate !== "") {
      fetchUserSessionList(
        pageData.currentPage,
        entries,
        sessionType,
        dateFilter.startDate,
        dateFilter.endDate
      );
    }
  }, [dateFilter.startDate, dateFilter.endDate]);

  const fetchSessionStats = async () => {
    try {
      const getDashboardData = await axiosHttp.get(`admin-dashboard`);
      if (getDashboardData.status === 200) {
        let data = getDashboardData.data.data;
        setSessionStats({
          totalSessions: data?.no_of_session || 0,
          sessionsHandled: data?.session_handled || 0,
          cancelledSessions: data?.cancelled_session || 0,
          rescheduledSessions: data?.rescheduled_session || 0,
          noShowSessions: 0 // Frontend only for now
        });
      }
    } catch (error) {
      console.log(error);
      setSessionStats({
        totalSessions: 0,
        sessionsHandled: 0,
        cancelledSessions: 0,
        rescheduledSessions: 0,
        noShowSessions: 0
      });
    }
  };

  const fetchUserSessionList = async (current, count, type, start, end) => {
    setLoading(true);
    let url = "";
    if (start && end && start > end) {
      toast.error("End date cannot be earlier than the start date");
      return;
      // url = `user-sessions?session=${type}&page=${current}&per_page=${count}`;
    } else if (start && end && start < end) {
      url = `user-sessions?status=${type}&page=${current}&per_page=${count}&startDate=${start}&endDate=${end}`;
    } else {
      url = `user-sessions?status=${type}&page=${current}&per_page=${count}`;
    }
    try {
      const getSessionList = await axiosHttp.get(url);
      if (getSessionList.status === 200) {
        let data = getSessionList.data.data;
        let pageValue = getSessionList.data.currentPage;
        let totalPageValue = getSessionList.data.lastPage;
        setPageData({
          currentPage: pageValue,
          totalPages: totalPageValue,
        });
        setSessionList(data);
        fetchSessionCount(current, count, type, start, end);
      }
    } catch (error) {
      console.log(error);
      setSessionList([]);
      setLoading(false);
    }
  };

  const fetchSessionCount = async (current, count, type, start, end) => {
    let url = "";
    if (start && end && start > end) {
      url = `user-sessions-count?status=${type}&page=${current}&per_page=${count}`;
    } else if (start && end && start < end) {
      url = `user-sessions-count?status=${type}&page=${current}&per_page=${count}&startDate=${start}&endDate=${end}`;
    } else {
      url = `user-sessions-count?status=${type}&page=${current}&per_page=${count}`;
    }
    try {
      const getSessionCount = await axiosHttp.get(url);
      if (getSessionCount.status === 200) {
        let data = getSessionCount.data.data;
        setSessionCount(data.count);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSessionCount(0);
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteUser = await axiosHttp.delete(`user/${id}`);
      if (deleteUser.status === 200) {
        setLoading(true);
        toast.success(deleteUser.data.message);
        fetchUserSessionList(pageData.currentPage, entries, sessionType);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDateFilter({ ...dateFilter, [name]: value });
  };

  const openModal = (sess) => {
    console.log('Session details:', sess);
    setSingleSession(sess);
    setShowModal(true);
  };

  const closeModal = () => {
    setSingleSession({});
    setShowModal(false);
  };

  // Search functionality to filter sessions by mentor or mentee name
  const getFilteredSessions = () => {
    if (!searchTerm.trim()) {
      return sessionList;
    }
    
    const searchLower = searchTerm.toLowerCase().trim();
    
    return sessionList.filter(session => {
      const mentorName = session?.mentor_name?.toLowerCase() || "";
      const menteeName = session?.mentee_name?.toLowerCase() || "";
      
      return mentorName.includes(searchLower) || menteeName.includes(searchLower);
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <huserCount4 className="title mb-5">Session Details</huserCount4>
          
          {/* Session Statistics Cards */}
          <div className="row mb-5">
            <div className="col mb-3">
              <div className="light-card session-stat-card">
                <div className="session-stat-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                      fill="#313131"
                    />
                  </svg>
                </div>
                <div className="session-stat-number">{sessionStats.totalSessions}</div>
                <div className="session-stat-label">No. of Sessions</div>
              </div>
            </div>
            <div className="col mb-3">
              <div className="green-card session-stat-card">
                <div className="session-stat-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                      fill="#313131"
                    />
                  </svg>
                </div>
                <div className="session-stat-number">{sessionStats.sessionsHandled}</div>
                <div className="session-stat-label">Sessions Handled</div>
              </div>
            </div>
            <div className="col mb-3">
              <div className="blue-card session-stat-card">
                <div className="session-stat-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                      fill="#313131"
                    />
                  </svg>
                </div>
                <div className="session-stat-number">{sessionStats.cancelledSessions}</div>
                <div className="session-stat-label">Cancelled Sessions</div>
              </div>
            </div>
            <div className="col mb-3">
              <div className="pink-card session-stat-card">
                <div className="session-stat-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                      fill="#313131"
                    />
                  </svg>
                </div>
                <div className="session-stat-number">{sessionStats.rescheduledSessions}</div>
                <div className="session-stat-label">Session Rescheduled</div>
              </div>
            </div>
            <div className="col mb-3">
              <div className="orange-card session-stat-card">
                <div className="session-stat-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                      fill="#313131"
                    />
                  </svg>
                </div>
                <div className="session-stat-number">{sessionStats.noShowSessions}</div>
                <div className="session-stat-label">No Show</div>
              </div>
            </div>
          </div>

          <div className="row mt-5 mb-5">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-3">
                  <h5 className="head">Session Filter</h5>
                </div>
                <div className="col-md-3">
                  <select
                    className="form-control"
                    value={sessionType}
                    onChange={(e) => setSessionType(e.target.value)}
                  >
                    <option value="Completed">Completed Session</option>
                    <option value="Failed">Failed Session</option>
                    <option value="Reschedule">Rescheduled Session</option>
                    <option value="NoShow">No Show Session</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by mentor or mentee name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4 text-right">
              <div className="row align-items-center justify-content-end">
                <div className="col-md-3">
                  <label>Date Filter</label>
                </div>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="date"
                    name="startDate"
                    value={dateFilter.startDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 d-flex align-items-center">
                  <label className="mr-2">-</label>
                  <input
                    className="form-control"
                    type="date"
                    name="endDate"
                    value={dateFilter.endDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-end mr-2">
            <div className="text-right">
              <p className="text-danger">{getFilteredSessions().length} sessions</p>
            </div>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th>
                    <input type="checkbox" class="form-control w-25 " />
                  </th>
                  <th>Date</th>
                  <th>Title</th>
                  <th>Mentor name</th>
                  <th>Mentee name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getFilteredSessions().length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {getFilteredSessions().length > 0 &&
                  getFilteredSessions().map((sess) => {
                    return (
                      <tr key={sess.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td class="border-right-0 ">
                          {moment(sess?.end_time).format("DD.MM.YYYY")}
                        </td>
                        <td class="border-right-0 ">
                          {sess?.service_name ? sess.service_name : "N/A"}
                        </td>
                        <td class="border-right-0 ">{sess?.mentor_name} </td>
                        <td class="border-right-0 ">{sess?.mentee_name} </td>

                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEye}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => openModal(sess)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(sess.user_id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="d-flex mt-5 justify-content-between ">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={(e) => setEntries(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            {pageData.totalPages > 1 && (
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageData.totalPages}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination justify-content-end"
                activeClassName="active"
                previousLabel="<"
                forcePage={pageData.currentPage - 1}
              />
            )}
          </div>
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title="View Call Detail"
        size="lg"
      >
        <Call sess={singleSession} />
      </ReusableModal>
    </div>
  );
};

export default SessionDetails;
